import { estimateStorageUsage, requestPersistentStorage } from "../storage/indexeddb.ts";
import { router } from "../router.ts";
import { store } from "../store.ts";

export async function renderSettings(
  root: HTMLElement,
  signal: AbortSignal,
): Promise<() => void> {
  const { usage, quota } = await estimateStorageUsage();
  if (signal.aborted) return () => {};
  const persisted = await requestPersistentStorage();
  if (signal.aborted) return () => {};

  const header = document.createElement("header");
  header.className = "app-header";
  const backBtn = document.createElement("button");
  backBtn.type = "button";
  backBtn.className = "btn";
  backBtn.dataset.action = "back";
  backBtn.textContent = "Back";
  const title = document.createElement("h1");
  title.textContent = "Settings";
  header.append(backBtn, title);

  const panel = document.createElement("section");
  panel.className = "settings-panel";

  const storageHeading = document.createElement("h2");
  storageHeading.textContent = "Storage";
  const usageP = document.createElement("p");
  usageP.textContent = `Used: ${formatBytes(usage)} / ${formatBytes(quota)}`;
  const persistP = document.createElement("p");
  persistP.textContent = `Persistent storage: ${persisted ? "granted" : "not granted"}`;

  const appearanceHeading = document.createElement("h2");
  appearanceHeading.textContent = "Appearance";
  const motionLabel = document.createElement("label");
  motionLabel.textContent = "Reduced motion ";
  const motionInput = document.createElement("input");
  motionInput.type = "checkbox";
  motionInput.dataset.action = "motion";
  motionInput.checked = Boolean(store.settings?.reducedMotion);
  motionLabel.appendChild(motionInput);

  const localNote = document.createElement("p");
  localNote.className = "status";
  localNote.textContent = "Your library stays on this device.";

  panel.append(storageHeading, usageP, persistP, appearanceHeading, motionLabel, localNote);
  if (signal.aborted) return () => {};
  root.replaceChildren(header, panel);

  backBtn.addEventListener("click", () => router.navigate({ name: "shelf" }));
  motionInput.addEventListener("change", async () => {
    await store.updateSettings({ reducedMotion: motionInput.checked });
  });

  return () => {};
}

function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** i).toFixed(1)} ${units[i]}`;
}
